import type { CatalogResponse } from './catalog';

export type FetchCatalogOptions = {
	baseUrl: string;
	locale: string;
	enterpriseId?: string | undefined;
	signal?: AbortSignal | undefined;
	// Bearer access token for the catalog endpoint. OPTIONAL: the catalog is
	// readable unauthenticated and returns the GLOBAL catalog, because the SPA
	// fetches it during bootstrap — on the sign-in screen and the OAuth callback —
	// before any token exists. Supplying a token additionally merges the caller's
	// ENTERPRISE-scoped overrides.
	//
	// (This previously required auth and 401'd for cookie-only requests, which
	// deadlocked the app: it could not render its own login page in the user's
	// language.)
	token?: string | undefined;
};

export const fetchCatalog = async ({
	baseUrl,
	locale,
	enterpriseId,
	signal,
	token,
}: FetchCatalogOptions): Promise<CatalogResponse> => {
	const params = new URLSearchParams({ locale });
	if (enterpriseId) {
		params.set('enterprise_id', enterpriseId);
	}
	const url = `${baseUrl}/api/translations/catalog?${params.toString()}`;
	const res = await fetch(url, {
		credentials: 'include',
		...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
		...(signal ? { signal } : {}),
	});
	if (!res.ok) {
		throw new Error(`catalog fetch failed: ${res.status}`);
	}
	return res.json();
};
